// src/pages/Home/index.jsx
import React from 'react';
import { Layout, Row, Col, Spin, Alert, Empty } from 'antd';
import AppHeader from '../../components/Header';
import AppFooter from '../../components/Footer';
import PostCard from '../../components/PostCard'; 
import './index.css';

const { Content } = Layout;

const Home = ({ posts, loading, error, loggedInUser, onLogout }) => {
    if (loading) {
        return (
            <Layout className="blog-layout">
                <AppHeader loggedInUser={loggedInUser} onLogout={onLogout} />
                <Content className="blog-content home-content">
                    <div className="loading-container">
                        <Spin size="large" tip="加载文章中..." />
                    </div>
                </Content>
                <AppFooter />
            </Layout>
        );
    }

    if (error) {
        return (
            <Layout className="blog-layout">
                <AppHeader loggedInUser={loggedInUser} onLogout={onLogout} />
                <Content className="blog-content home-content">
                    <div className="error-container">
                        <Alert message="错误" description={error} type="error" showIcon />
                    </div>
                </Content>
                <AppFooter />
            </Layout>
        );
    }

    return (
        <Layout className="blog-layout">
            <AppHeader loggedInUser={loggedInUser} onLogout={onLogout} />
            <Content className="blog-content home-content">
                <div className="posts-container">
                    {posts.length === 0 ? (
                        <Empty
                            description="暂无文章，登录后快来发布第一篇吧！"
                            style={{ padding: '50px 0' }}
                        />
                    ) : (
                        <Row gutter={[24, 24]}>
                            {posts.map(post => (
                                <Col key={post.id} xs={24} sm={12} md={8} lg={6}>
                                    <PostCard post={post} />
                                </Col>
                            ))}
                        </Row>
                    )}
                </div>
            </Content>
            <AppFooter />
        </Layout>
    );
};

export default Home;
